import { PaginatedResult } from "@/interfaces/common/PaginatedResult";
import { Store } from "@/interfaces/domain/Store";
import { StorePaymentMethod } from "@/interfaces/domain/StorePaymentMethod";
import { api, image_path_credit_cards, image_path_stores } from "@/services/api";

export type LocationParams = {
  latitude: number;
  longitude: number;
};

const defaultSelect = "nome_fantasia foto_estabelecimento";

function formatWithImage(data: PaginatedResult<Store>) {
  const withImages = data.docs.map((item) => ({
    ...item,
    foto_estabelecimento: `${image_path_stores}/${item.foto_estabelecimento}`,
  }));
  data.docs = withImages;
  return data;
}

export async function getHighlightStoresRequest() {
  const { data } = await api.get<PaginatedResult<Store>>(
    `/v2/estabelecimentos/destaques?select=${defaultSelect}`
  );
  return formatWithImage(data);
}

export async function getStoresRequest({
  page = 1,
  typeId,
  limit = 10,
}: {
  page: number;
  limit?: number;
  typeId?: string;
}) {
  let url = `/estabelecimentos?page=${page}limit=${limit}&select=${defaultSelect}`;
  if (typeId) {
    url += `&tipo=${typeId}`;
  }
  const { data } = await api.get<PaginatedResult<Store>>(url);
  return formatWithImage(data);
}

export async function getStoresByLocationRequest(page = 1, params: LocationParams, limit = 10) {
  const { data } = await api.get<PaginatedResult<Store>>(
    `/v2/estabelecimentos/geolocation?page=${page}&lat=${params.latitude}&long=${params.longitude}&limit=${limit}&select=${defaultSelect}`
  );
  return formatWithImage(data);
}

export async function getStoresByClientIdRequest(page = 1, clientId: string, limit = 10) {
  const { data } = await api.get<PaginatedResult<Store>>(
    `/v2/estabelecimentos/home/${clientId}?page=${page}&limit=${limit}&select=${defaultSelect}`
  );
  return formatWithImage(data);
}

export async function getStoreByIdRequest(id: string) {
  const { data } = await api.get<Store>(`/estabelecimentos/${id}`);
  if (data) {
    data.foto_estabelecimento = `${image_path_stores}/${data?.foto_estabelecimento}`;
    data.informacoes_adicionais.banner = `${image_path_stores}/${data.informacoes_adicionais?.banner}`;
  }
  return data;
}

export async function getStorePaymentMethodsRequest(storeId: string) {
  const { data } = await api.get<StorePaymentMethod[]>(
    `/estabelecimentos/${storeId}/cartoes-aceitos`
  );
  return data?.map((item) => ({
    ...item,
    logo: `${image_path_credit_cards}/${item.logo}`,
  }));
}
